__turbopack_context__.v({
  "container": "Logos-module__DxLEDW__container",
  "logo": "Logos-module__DxLEDW__logo",
  "logos": "Logos-module__DxLEDW__logos",
  "logosSlide": "Logos-module__DxLEDW__logosSlide",
  "logosSlideOffset": "Logos-module__DxLEDW__logosSlideOffset",
  "scroll": "Logos-module__DxLEDW__scroll",
});
